import React from 'react';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1 className="display-large">Terms of Service</h1>
        <p className="body-medium" style={{ marginTop: '24px', color: 'var(--text-muted)' }}>
          Last Updated: January 17, 2025
        </p>
      </section>

      <section className="legal-content">
        <div className="legal-text">
          <h2 className="heading-1">1. Agreement to Terms</h2>
          <p className="body-medium">
            These Terms of Service ("Terms") constitute a legally binding agreement between you and EAET LLC ("Company", "we", "us", or "our"), a Delaware limited liability company with its principal place of business at Wilmington, DE 19801, USA, concerning your access to and use of the EAET platform and services.
          </p>
          <p className="body-medium">
            By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use our services.
          </p>

          <h2 className="heading-1">2. Description of Services</h2>
          <p className="body-medium">
            EAET provides an AI agent platform ("Platform") that enables users to deploy, manage, and operate artificial intelligence agents for process automation. Our services include:
          </p>
          <ul className="body-medium legal-list">
            <li>Access to pre-built AI agents across multiple categories</li>
            <li>Platform for building and deploying custom AI agents</li>
            <li>Integration capabilities with third-party systems</li>
            <li>Analytics, monitoring, and management tools</li>
            <li>Technical support and documentation</li>
          </ul>

          <h2 className="heading-1">3. Account Registration and Security</h2>
          <p className="body-medium">
            To use our Platform, you must create an account. You agree to:
          </p>
          <ul className="body-medium legal-list">
            <li>Provide accurate, current, and complete information during registration</li>
            <li>Maintain the security of your account credentials</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Accept responsibility for all activities under your account</li>
          </ul>

          <h2 className="heading-1">4. Acceptable Use Policy</h2>
          <p className="body-medium">
            You agree not to use the Platform to:
          </p>
          <ul className="body-medium legal-list">
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe upon intellectual property rights of others</li>
            <li>Transmit malicious code, viruses, or harmful content</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Use the service for fraudulent or deceptive purposes</li>
            <li>Reverse engineer or attempt to extract source code</li>
            <li>Resell or redistribute our services without authorization</li>
          </ul>

          <h2 className="heading-1">5. Intellectual Property Rights</h2>
          <p className="body-medium">
            The Platform, including all software, content, and technology, is owned by EAET LLC and protected by United States and international intellectual property laws. We grant you a limited, non-exclusive, non-transferable license to use the Platform in accordance with these Terms.
          </p>
          <p className="body-medium">
            You retain ownership of any data you input into the Platform. By using our services, you grant us a limited license to process your data solely for the purpose of providing our services.
          </p>

          <h2 className="heading-1">6. Payment Terms</h2>
          <p className="body-medium">
            Fees for our services are as specified in your selected pricing plan. You agree to:
          </p>
          <ul className="body-medium legal-list">
            <li>Pay all fees in accordance with the pricing terms</li>
            <li>Provide valid payment information</li>
            <li>Pay applicable taxes</li>
            <li>Accept that fees are non-refundable except as required by law</li>
          </ul>
          <p className="body-medium">
            We reserve the right to modify pricing with 30 days notice. Continued use after price changes constitutes acceptance.
          </p>

          <h2 className="heading-1">7. Data and Privacy</h2>
          <p className="body-medium">
            Your use of the Platform is subject to our Privacy Policy. We implement industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure.
          </p>

          <h2 className="heading-1">8. Service Level and Availability</h2>
          <p className="body-medium">
            We strive to maintain 99.9% uptime for our Platform. However, we do not guarantee uninterrupted access and may perform maintenance that temporarily affects availability. We are not liable for any downtime or service interruptions.
          </p>

          <h2 className="heading-1">9. Limitation of Liability</h2>
          <p className="body-medium">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, EAET LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
          </p>
          <p className="body-medium">
            OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
          </p>

          <h2 className="heading-1">10. Disclaimers</h2>
          <p className="body-medium">
            THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </p>

          <h2 className="heading-1">11. Indemnification</h2>
          <p className="body-medium">
            You agree to indemnify, defend, and hold harmless EAET LLC, its officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses arising from your use of the Platform or violation of these Terms.
          </p>

          <h2 className="heading-1">12. Termination</h2>
          <p className="body-medium">
            We may suspend or terminate your access to the Platform at any time for violation of these Terms or for any other reason at our sole discretion. You may terminate your account at any time by contacting us through our contact form.
          </p>
          <p className="body-medium">
            Upon termination, your right to use the Platform immediately ceases. Provisions that by their nature should survive termination shall survive.
          </p>

          <h2 className="heading-1">13. Modifications to Terms</h2>
          <p className="body-medium">
            We reserve the right to modify these Terms at any time. We will notify you of material changes via email or through the Platform. Continued use after modifications constitutes acceptance of the revised Terms.
          </p>

          <h2 className="heading-1">14. Governing Law and Dispute Resolution</h2>
          <p className="body-medium">
            These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict of law principles. Any disputes shall be resolved through binding arbitration in Delaware, except that either party may seek injunctive relief in court.
          </p>

          <h2 className="heading-1">15. Export Compliance</h2>
          <p className="body-medium">
            You agree to comply with all applicable export and import laws and regulations. You may not use the Platform if you are located in a country subject to U.S. embargo or if you are on any U.S. government list of prohibited parties.
          </p>

          <h2 className="heading-1">16. Miscellaneous</h2>
          <p className="body-medium">
            These Terms constitute the entire agreement between you and EAET LLC. If any provision is found unenforceable, the remaining provisions will remain in effect. Our failure to enforce any right or provision does not constitute a waiver.
          </p>

          <h2 className="heading-1">17. Contact Information</h2>
          <p className="body-medium">
            For questions about these Terms, please use our contact form.
          </p>
          <div className="contact-info">
            <p className="body-medium"><strong>EAET LLC</strong></p>
            <p className="body-medium">Wilmington, DE 19801</p>
            <p className="body-medium">United States of America</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
